<template>
  <div id="selectIsRegisteredModal">
    <div class="modal-card" style="width:600px;height:600px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body" style="width: 100%;text-align: left">
        <div class="condition-area">
          <p style="font-size:32px;text-align:center;">ケア オーケストレーターの<br>ご利用状況を選択してください</p>
          <fieldset style="margin-top:30px;margin-bottom:30px">
            <div class="block" style="text-align:center;margin-top:80px;">
              <b-radio size="is-medium" v-model="isRegistered" :native-value="false"><span style="font-size:18px">未利用</span></b-radio>
              <b-radio size="is-medium" v-model="isRegistered" :native-value="true"><span style="font-size:18px">利用中</span></b-radio>
            </div>
          </fieldset>
        </div>
      </section>
      <div style="display: flex;justify-content: space-between;margin-bottom:10px;padding-left: 30px;padding-right: 30px;">
        <button class="button" type="button" @click="back" style="display:inline-block;background-color:#6eadf3;color:whitesmoke">戻る</button>
        <button class="button" type="button" @click="save" :disabled="isRegistered===null" style="display:inline-block;background-color:#6eadf3;color:whitesmoke">次へ</button>
      </div>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "selectIsRegisteredModal",
  props:["title"],
  methods: {
    back: function(){
      this.$router.go(-1);
    },
    save: function() {
      if(this.isRegistered === null){
        this.showMessage('選択されていません。');
        return
      }
      this.$parent.close();
      this.$emit('setIsRegistered', this.isRegistered);
      if(this.isRegistered){
          this.requestCo()
      }
    },
    requestCo: async function() {
      this.completeFlg = false
      var executeApi = this.setBelongsCoInUsePOST;
      var successCallBack = this.setBelongsCoInUsePOSTSuccess;
      var errorCallBack = this.setBelongsCoInUsePOSTError;
      // WebAPI Call
      await this.apiCall(executeApi, successCallBack, errorCallBack)
      if(this.isRegistered===true){
        this.$router.push({
          name: "COApplicationForRegistered",
        })
      }
    },
    setBelongsCoInUsePOST: function(client) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      return client.apis.externalCo.setBelongsCoInUsePOST({
        body:{
          belongsId:userInfo.belongsId
        }
      });
    },
    setBelongsCoInUsePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.completeFlg = true;
    },
    setBelongsCoInUsePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    return {
      isRegistered:false,
    };
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/selectIsRegisteredModal.vue